import {createTheme} from "@mui/material"


export const theme = createTheme({
  palette: {
    primary: {
      main: "rgb(22, 48, 109)",
    },
  },
  typography: {
    fontFamily: '"Gibson", sans-serif',
  },
});
